import { inject, Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DYNAMIC_IDENTIFIER, SPINNER_AREA, SpinnerArea, UserInfo } from "../model/common.model";
import { NgxSpinnerService } from "ngx-spinner";
import { TitleSchema, TITLE_TYPE, exportConfig } from "../model/dynamic-data-table.model";
import { DynamicFormArray, FIELD_TYPES, FormFieldConfig } from "../model/form.model";
import { FieldNames } from "../model/form-fields.model";
import { Subject } from "rxjs";
 

@Injectable({
  providedIn: 'root'
})
export class CommonUtils {
  private readonly _snackBar = inject(MatSnackBar);
  private readonly ngxspinner = inject(NgxSpinnerService);
  public profileDataOnChange:Subject<UserInfo> = new Subject();
  public userInfo:any = null;
  constructor() { }
  getDefaultMonth(){
    const currentDate = new Date();
    const day = currentDate.getDate();
    const monthsToSubtract = day <= 6 ? 2 : 1;
    const targetDate = new Date();
    targetDate.setMonth(targetDate.getMonth() - monthsToSubtract);
    return targetDate.toLocaleString('default', { month: 'numeric' });
  }
  getDafaultYear(){
    return new Date().getFullYear() .toString()
  }
  showMatSnackBar(message: string, action?: string){
    const config:MatSnackBarConfig = {
      duration:2000,
      panelClass:"cbl-mat-snackbar"
    }
    this._snackBar.open(message, action, config);
  }
  spinner(action:'show'|'hide', spinnerName?:SpinnerArea,){
    spinnerName = spinnerName ?? SPINNER_AREA['FullScreen'];
    if(action === 'show'){
      this.ngxspinner.show(spinnerName)
    }else{
      this.ngxspinner.hide(spinnerName)
    }
  }
  getMonthAndYearForPeriod(period: any) {
    const today = new Date();
    const currentDay = today.getDate();
    const endDate = new Date(today.getFullYear(), today.getMonth(), 1);
    if (currentDay < 5) {
      endDate.setMonth(endDate.getMonth() - 2); 
    } else {
      endDate.setMonth(endDate.getMonth() - 1); 
    }
    const startDate = new Date(endDate.getFullYear(), endDate.getMonth()+1, 1);
    startDate.setMonth(startDate.getMonth() - period);
    const periodResult = {
      startMonth: startDate.toLocaleString('default', { month: 'long' }),
      startYear: startDate.getFullYear(),
      endMonth: endDate.toLocaleString('default', { month: 'long' }),
      endYear: endDate.getFullYear(),
    };
    if(periodResult['startMonth'] === periodResult['endMonth'] && periodResult['startYear'] === periodResult['endYear']){
      return `${periodResult['startMonth']} ${periodResult['startYear']}`
    }
    return `${periodResult['startMonth']} ${periodResult['startYear']} - ${periodResult['endMonth']} ${periodResult['endYear']}`
  }
  updateTitle(sectionConfig: { titleSchema: TitleSchema | Record<string, TitleSchema>, filterFields: FormFieldConfig[], globalTitleFields: any }, dynamicfield?: FormFieldConfig, chartRef?: any) {
    const selectedField = DYNAMIC_IDENTIFIER['selectedField']
    const updateDynamicTitle = (titleSchema: TitleSchema, filterField?: FormFieldConfig, filterFields?:Array<FormFieldConfig>) => {
      let title =  structuredClone(titleSchema['title']);
      let subTitle = structuredClone(titleSchema['subTitle']) ?? ''
      const replaceIdentifiers = (key:string, label:string)=>{
        title = title.replaceAll(key, label);
        subTitle = subTitle.replaceAll(key, label);
      }
      if (sectionConfig['globalTitleFields']) {
        Object.keys(sectionConfig['globalTitleFields']).forEach(key => {
          replaceIdentifiers(key, sectionConfig['globalTitleFields'][key]);
        })
      }
      if (filterField) {
        if (filterField['fieldName'] === FieldNames['Period']) {
          const label = this.getMonthAndYearForPeriod(filterField['selectedValue']);
          replaceIdentifiers(DYNAMIC_IDENTIFIER['period'], label);
        }
        let displayValue = filterField['selectedValue'];
        if (filterField['fieldType'] === FIELD_TYPES['DROPDOWN']) {
          if (Array.isArray(displayValue)) {
             displayValue = filterField['options']?.filter(x => displayValue.includes(x['fieldValue'])).map(x => x.fieldLabel).join(', ') ?? displayValue.join(', ');
          } else {
            displayValue = filterField['options']?.find(x => x.fieldValue === displayValue)?.fieldLabel ?? displayValue;
          }
        }
        replaceIdentifiers(selectedField, displayValue);
        filterFields?.forEach(field=>{
          if(title.includes(`$|-${field['fieldName']}-|$`) || subTitle.includes(`$|-${field['fieldName']}-|$`)){
            let value = field['selectedValue']
            if(field['fieldType'] === FIELD_TYPES['DROPDOWN']){
              if (Array.isArray(value)) {
                value = field['options']?.filter(x => value.includes(x.fieldValue)).map(x => x.fieldLabel).join(', ') ?? value.join(', ');
              } else {
                value = field['options']?.find(x=>x.fieldValue === value)?.fieldLabel ?? field['selectedValue']
              }
            }
            replaceIdentifiers(`$|-${field['fieldName']}-|$`, value);
          }
        });
      }
      const updateTitleWithFilterFields = () => {
        if (sectionConfig.filterFields) {
          sectionConfig.filterFields.forEach(filterField => {
            const identifier = DYNAMIC_IDENTIFIER['startKey'] + filterField['fieldName'] + DYNAMIC_IDENTIFIER['endkey'];
            if (title.includes(identifier) || subTitle.includes(identifier)) {
              replaceIdentifiers(identifier, filterField['selectedValue']);
            }
          })
        }
        return title
      }
      if (title.includes(DYNAMIC_IDENTIFIER['startKey']) && title.includes(DYNAMIC_IDENTIFIER['endkey'])) {
        updateTitleWithFilterFields()
      }
      return {
        title: title,
        subTitle: subTitle
      };
    };
    const titleSchema: any = sectionConfig['titleSchema'];
    let titleResult = {
      title: '',
      subTitle: ''
    };
    let currentSchema = null;
    if (titleSchema['type'] === TITLE_TYPE['Static']) {
      titleResult['title'] = titleSchema['label'] = titleSchema['title'];
      titleResult['subTitle'] = titleSchema['subLabel'] = titleSchema['subTitle'];
      if (chartRef) {
        chartRef.setTitle({ text: titleSchema['label'] });
      }
      return titleResult;
    } else if (dynamicfield) {
      currentSchema = titleSchema[dynamicfield['fieldName']];
    } else if (sectionConfig.filterFields.length > 0 && Object.keys(titleSchema).length > 0) {
      const fieldKeys = Object.keys(titleSchema);
      sectionConfig.filterFields.forEach(field => {
        if (fieldKeys.includes(field['fieldName']) && (field['selectedValue'] !== '' && field['selectedValue'] !== null && field['selectedValue'] !== undefined)) {
          currentSchema = titleSchema[field['fieldName']];
          dynamicfield = field
        }
      })
      if (currentSchema === null) {
        const field: FormFieldConfig = Object.values(sectionConfig.filterFields)[0];
        currentSchema = titleSchema[field['fieldName']];
        dynamicfield = field
      }
    } else {
      currentSchema = titleSchema;
    }
    titleResult = updateDynamicTitle(currentSchema, dynamicfield, sectionConfig.filterFields);
    titleSchema['label'] = titleResult['title']
    titleSchema['subLabel'] = titleResult['subTitle'];
    if (chartRef) {
      chartRef.setTitle({ text: titleResult['title'] }, { text: titleResult['subTitle'] });
    }
    return titleResult;
  }
  setDefaultValueForOptionsField(field:FormFieldConfig){
    if(field['fieldName'] === FieldNames['Month']){
    const defaultMonth = this.getDefaultMonth();
    if (field.multiple) {
      field.defaultValue = [defaultMonth];
      field.selectedValue = [...field.defaultValue];
    } else {
      field.defaultValue = defaultMonth;
      field.selectedValue = field.defaultValue;
    }
    return;
  }
  if (field.fieldName === FieldNames.CalendarYear) {
      field['defaultValue'] = this.getDafaultYear()
  }
    field['selectedValue'] = field['defaultValue']
}
  formatExcelData(exportConfig:exportConfig, data: Array<any>, filterSchema?:DynamicFormArray) {
    let result = data ?? [];
    const exportSchema = exportConfig?.schema;
    if (exportSchema) {
      const selectedFields:Record<string,{label:string,value:any}> = {};
      if(filterSchema && filterSchema?.FieldsArray?.length >0){
        filterSchema.FieldsArray.forEach(filterField=>{
          if(filterField['selectedValue'] !== '' && filterField['selectedValue'] !== null && filterField['selectedValue'] !== undefined){
            selectedFields[filterField['fieldName']] = {
              label:filterField['displayName'],
              value:filterField['selectedValue']
            }
            if(filterField['options'] && filterField['options'].length>0){
              const selectedValue = filterField['selectedValue'];
              if(Array.isArray(selectedValue)){
                selectedFields[filterField['fieldName']]['value'] = 
                filterField['options'].filter(x=>selectedValue.includes(x['fieldValue'])).map(x=>x.fieldLabel).join(', ');
              }else{
                selectedFields[filterField['fieldName']]['value'] = filterField['options'].find(x=>x.fieldValue === selectedValue)?.fieldLabel;
              }
              
            }
          }
        })
      }
      result = result.map(item => {   
        const transformed: any = {};
        for (const key in exportSchema) {
          if (item.hasOwnProperty(key)) {
            let value = item[key];
            if(exportConfig?.dateFields?.includes(key) && !['', null, undefined].includes(value)){
              const date = new Date(value)
              value = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`
            }
            if(exportConfig?.attachmentFields?.includes(key) && !['', null, undefined].includes(value)){
              value = value.map((x:any)=>x.displayName).join(', ');
            }
            if (exportConfig?.dropDownMapping?.[key]) {
              transformed[exportSchema[key]] = value.map((x: string | number)=> exportConfig.dropDownMapping[key][x])
            } else if (exportConfig?.isCamelCase?.includes(key)) {
              transformed[exportSchema[key]] = this.toCamelCase(value);
            } else {
              transformed[exportSchema[key]] = item[key];
            }
          }
          if(key === DYNAMIC_IDENTIFIER['selectedField']){
            if(exportSchema[key].length>0){
                exportSchema[key].forEach((selectedField: string)=>{
                if(selectedFields.hasOwnProperty(selectedField)){
                  transformed[selectedFields[selectedField]['label']] = selectedFields[selectedField]['value'];
                }
              })
            }
            
          }
        }
        return transformed;
      });
      const footerSchema = exportConfig?.footer;
      if(footerSchema){
        Object.keys(footerSchema).forEach(footerInfo=>{
          if(footerInfo === 'sum'){
            const footerResult:any = {};
            footerSchema[footerInfo].forEach((fieldInfo:any)=>{
              if(fieldInfo.hasOwnProperty('label')){
                footerResult[exportSchema[fieldInfo['fieldKey']]] = fieldInfo['label'];
              }else if(fieldInfo.hasOwnProperty('sumBy')){
                footerResult[exportSchema[fieldInfo['fieldKey']]] = data?.reduce((sum, item) => sum + Number(item[fieldInfo['sumBy']]), 0); 
              }
            })
            result.push(footerResult)
          }
        })
      }
    }

    return result;
  }
  getFormattedDate(): string {
    const istDate = new Date();
    const month = istDate.getMonth() + 1;
    const dd = ('0' + istDate.getDate()).slice(-2);
    const mm = ('0' + month).slice(-2);
    const yy = ('0' + istDate.getFullYear().toString().slice(-2)).slice(-2);
    const hh = ('0' + istDate.getHours()).slice(-2);
    const mi = ('0' + istDate.getMinutes()).slice(-2);
    const ss = ('0' + istDate.getSeconds()).slice(-2);
    return `${mm}_${dd}_${yy}_${hh}_${mi}_${ss}`;
  }
  getBucketName(): string {
    let bucketName;
    const hostname = location.hostname.toLowerCase().trim()
    if (hostname === 'cblrd.lexus.com') {
        bucketName = 'cbl-exports'
    } else if (hostname === 'qa.cblrd.lexus.com') {
        bucketName = 'cbl-subprod-exports'
    } else {
        bucketName = 'cbl-subprod-exports'
    }
    return bucketName;
  }
clientSideSort(data: any[], activeSorts: any[]) {
  const isNullish = (val: any) => val === null || val === undefined || val === '';
  const isNumberLike = (val: any) => typeof val === 'string' && !Number.isNaN(Number(val));
  const isDateLike = (val: any) => typeof val === 'string' && !Number.isNaN(Date.parse(val));

  const normalizeValue = (val: any) => {
    if (isNumberLike(val)){return Number(val)};
    if (isDateLike(val)){return new Date(val)};
    return val;
  };

  const compareValues = (a: any, b: any, direction: number) => {
    if (isNullish(a) && isNullish(b)){return 0};
    if (isNullish(a)){return -1 * direction};
    if (isNullish(b)){return 1 * direction};

    a = normalizeValue(a);
    b = normalizeValue(b);

    if (a < b){return -1 * direction};
    if (a > b){return 1 * direction};
    return 0;
  };

  return data.slice().sort((a, b) => {
    for (const sort of activeSorts) {
      const direction = sort.direction === 'asc' ? 1 : -1;
      const result = compareValues(a[sort.id], b[sort.id], direction);
      if (result !== 0){return result};
    }
    return 0;
  });
}

groupBy<T>(array: T[], key: keyof T): Record<string, T[]> {
  return array.reduce((result, item) => {
    const groupKey = String(item[key]);
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    result[groupKey].push(item);
    return result;
  }, {} as Record<string, T[]>);
}
  readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          const base64 = result.split(',')[1];
          resolve(base64);
        } else {
          reject(new Error("Unexpected result type or null result"));
        }
      };
      reader.onerror = error => reject(error); 
      reader.readAsDataURL(file);
    });
  }
  toCamelCase(value:any){
    if(!value){
      return ''
    }
    return value
      .toString()
      .trim()
      .split(' ')
      .map((word:string) => {
        if (!word) {return ''};
        if (word.toLowerCase() === 'id'){ return 'ID'};
        if (word.toLowerCase() === 'oem'){ return 'OEM'};
        const lowerWord = word.toLowerCase();
        if (lowerWord === 'pc') { return 'PC' };
        if (lowerWord === 'pc?') { return 'PC?' };
        if (lowerWord === 'hq') { return 'HQ' };
        if (lowerWord === 'tci') { return 'TCI' };
        if (lowerWord === 'ase') { return 'ASE' };
        if (lowerWord === 't-ten') { return 'T-TEN' };
        if (lowerWord === 'ase-lexus') { return 'ASE-Lexus' };

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ')
  }

  getSecureRandomNumber(max: number): number {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return array[0] % max;
  }
}